export default __webpack_public_path__ + "static/media/announcement_5@3x.989840b8.png";